var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSingleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4 11.575L15.3 7.675C15.4833 7.49167 15.575 7.25833 15.575 6.975C15.575 6.69167 15.4833 6.45833 15.3 6.275C15.1167 6.09167 14.8833 6 14.6 6C14.3167 6 14.0833 6.09167 13.9 6.275L9.3 10.875C9.1 11.075 9 11.3083 9 11.575C9 11.8417 9.1 12.075 9.3 12.275L13.9 16.875C14.0833 17.0583 14.3167 17.15 14.6 17.15C14.8833 17.15 15.1167 17.0583 15.3 16.875C15.4833 16.6917 15.575 16.4583 15.575 16.175C15.575 15.8917 15.4833 15.6583 15.3 15.475L11.4 11.575Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSingleArrowLeft);
export default __webpack_public_path__ + "static/media/ICON_SINGLE_ARROW_LEFT.b244e2d987a723a21dafbdb4d0854f1a.svg";
export { ForwardRef as ReactComponent };